<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em">Writing any book is tough – ours took over 5 years. During that time, we have been supported by many wonderful people. Two in particular have provided business, philosophical and emotional support and encouragement as long-standing members of our Advisory Board: Rachel Wheeler and Tony Voller.</p><br/>
<p style="text-indent:0em">We have worked with many great leaders and collaborators during our long careers and each of them have provided inspiration to support our belief that business can make a difference.</p><br/>
<p style="text-indent:0em">Finally, our team. In our consultancy azzur limited, we have had the privilege of working with great consultants as part of our team, each of whom have contributed to the evolution of our thinking on Conscious Leadership</p><br/>
<p style="text-indent:0em">To each and every person who has generously offered support and inspiration, we would like to thank you from the bottom of our hearts and invite you to get ready for the next book!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3a1585fc